import React, { Component, PropTypes } from "react";
import {Table, Input, Button, Icon, Row, Col, Tooltip, message, Modal, Dropdown, Menu, Divider} from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import css from './index.css';
import {hasAuth} from "../../../utils/NHCore";
import YwxblcxTable from './ywxblcxTable';


const baseUrlPath = "/tjcx/ywxblcx"; //基础路径


/**
 * hjblcx列表
 * @author Xiafanglin
 * @date 2018-03-20 09:56:14
 * Version: 1.0
 */
export default class YwxblcxTab extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initParams: {},
            selectKey: '',
            columns:[],
        }
    }
    componentWillMount() {
        const columnConst = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50',
            }, {
                title: '学号',
                dataIndex: 'XH',
                search: 'input',
                width: '120',
                searchType:"input"
            },{
                title: '姓名',
                dataIndex: 'XM',
                search: 'input',
                width: '90',
                searchType:"input"
            }, {
                title: '性别',
                width: '70px',
                dataIndex: 'XB',
                searchType:"select"
            },{
                title: '校区',
                width: '200',
                dataIndex: 'XQMC',
                searchType:"select"
            },{
                title: '院系',
                width: '200',
                search: 'input',
                dataIndex: 'BMMC',
                searchType:"select"
            },{
                title: '专业',
                width: '200',
                search: 'input',
                dataIndex: 'ZYMC',
                searchType:"select",
                parentField:"BMMC"
            },{
                title: '班级',
                width: '200',
                search: 'input',
                dataIndex: 'BJMC',
                searchType:"select",
                parentField:"ZYMC"
            },{
                title: '环节名称',
                dataIndex: 'HJMC',
                search: 'input',
                width: '90',
                searchType:"input"
            }
        ];
        this.setState({
            selectKey: this.props.selectKey,
            columns:columnConst,
        },() => {
            this.getColumn(this.state.selectKey);
        });
    }
    //获取动态字段
    getColumn = (lchjid) => {
        if (lchjid) {
            NHFetch(baseUrlPath+"/getYwxDate","get","lchjid="+lchjid).then(
                res => {
                    if (res.data) {
                        let columnLet = this.state.columns;
                        console.log(columnLet)
                        res.data.map((item) => {
                            let column = {
                                title: item.ZDMC,
                                width: '200',
                                search: 'input',
                                dataIndex: "'"+item.ZDBZ+"'",
                            };
                            columnLet.push(column);
                        });
                        this.setState({
                            columns: columnLet
                        });
                    }
                }
            )
        }

    }

    handleOtpBtnClick = () => {
        this.refs.nhTable.exportExcel('业务项办理信息');
    }


    render() {
        return(
            <div className={css.main_right_content} style={{height:getSize().windowH-230}}>
                <div className={css.table} >
                    <YwxblcxTable ref='nhTable'
                                 rowKey={record =>record.PKID} //TODO 把此处的信息改成自己的
                                 columns={this.state.columns}
                                 sign={this.props.selectKey}
                                 initParams={this.props.initParams}
                                 rangeFilter={true}
                    >
                        {hasAuth('zhxg_yxgl_tjcx_ywxblcx:export')?<Button type="primary" ghost style={{marginLeft:10}} onClick={this.handleOtpBtnClick}>导出</Button>:undefined}
                    </YwxblcxTable>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/ywxblcx/ywxblcxTab.js